import axios from '@lib/axios';
import { useMutation } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';

interface Props {
  agendaId?: string;
	onSuccess?: (res: AxiosResponse) => void;
  onError?: () => void;
}

export const useSendAgendaTestEmail = ({
  agendaId,
	onSuccess,
  onError
}: Props) => {
	const {
		mutate: onSendTestEmail,
		...rest
	} = useMutation({
		mutationFn: async () => axios.post(`/agendas/${agendaId}/send-email-test`),
		onSuccess,
    onError
	});

	return { onSendTestEmail, ...rest };
};